import { overrides } from 'vue-tour/.eslintrc'
import AbstractService from '@/services/abstractService'

class PaymentService extends AbstractService {
    endpoint = '/payments';

    index(contractId) {
      return this.http.get(`invoices/${contractId}${this.endpoint}`, { params: { dashboard: true } })
    }

    post(contractId, data) {
      console.log('data', data)
      // define append form
      const formData = new FormData()
      for (const key in data) {
        formData.append(key, data[key])
      }
      return this.http.post(`invoices/${contractId}${this.endpoint}`, formData)
    }

    put(contractId, invoiceId, data) {
      console.log('dataggg', data)
      // define append form
      const formData = new FormData()
      for (const key in data) {
        if (data[key] === null) {
          formData.append(key, '')
        } else {
          formData.append(key, data[key])
        }
      }
      return this.http.put(`invoices/${contractId}${this.endpoint}/${invoiceId}`, formData)
    }

    delete(contractId, data) {
    return this.http.delete(`invoices/${contractId}${this.endpoint}/${data}`)
  }

    getPaymentMethods() {
        return this.http.get('paymentMethods', { params: { dashboard: true } })
    }

}

const Service = new PaymentService()

export default Service
